/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { co_getplato_grid_sales_features_draft_filter_FilterRequest } from './co_getplato_grid_sales_features_draft_filter_FilterRequest';
export type co_getplato_grid_sales_features_draft_filter_Request = {
    filter: co_getplato_grid_sales_features_draft_filter_FilterRequest;
    list_type: co_getplato_grid_sales_features_draft_filter_Request.list_type;
};
export namespace co_getplato_grid_sales_features_draft_filter_Request {
    export enum list_type {
        CUSTOMERS = 'CUSTOMERS',
        USERS = 'USERS',
    }
}

